<template>
    <!-- This component doesn't render anything visible -->
    <div style="display: none;"></div>
</template>

<script>
import { defineComponent, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useMetaManager } from '@/composables/useMetaManager'

export default defineComponent({
    name: 'MetaManager',
    setup() {
        const route = useRoute()
        const { updateMeta } = useMetaManager()

        // Watch for route changes and update meta accordingly
        watch(() => route, (to) => {
            if (to.meta.pageName) {
                updateMeta({
                    title: to.meta.pageName
                })
            }
        }, { immediate: true, deep: true })

        return {}
    }
})
</script>